import { Route, Switch, useRouteMatch } from 'react-router-dom';

import TaskDetailRoute from './[taskId]';
import { TasksSubTab } from './constants';
import TaskListView from './TaskListView';

export { TasksSubTab } from './constants';

const TasksPage = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route
        path={`${path}/${TasksSubTab.EQUIP_STAFF}/:taskId`}
        component={TaskDetailRoute}
      />
      <Route
        path={`${path}/${TasksSubTab.PATIENT_AND_SUPPORTS}/:taskId`}
        component={TaskDetailRoute}
      />
      <Route
        path={`${path}/:taskId([0-9a-f-]{36})`}
        component={TaskDetailRoute}
      />
      <Route component={TaskListView} />
    </Switch>
  );
};

export default TasksPage;
